// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_bj-0";